import styled from 'styled-components';
import colors from '../../../assets/css/colors';
import { below, above } from '../../../assets/css/media';

const LeagueStatusLabel = styled.div`
	font-size: 10px;
	line-height: 1.4;
	color: ${colors.nrlDarkGreenHover};
	text-transform: uppercase;

	${above.tablet`
		white-space: nowrap;
	`}

	${below.phone`
		display: none;
	`}
`;

export default LeagueStatusLabel;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/LeagueStatusLabel.js